import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modals: {
    view: {
      open: false,
      id: null,
    },
    edit: {
      open: false,
      id: null,
    },
    delete: {
      open: false,
      id: null,
    },
  },
};

const emailTemplatesControlSlice = createSlice({
  name: "emailTemplatesControl",
  initialState: initialState,
  reducers: {
    openModal: (state, action) => {
      const { id, modalType } = action.payload;
      state.modals[modalType] = { open: true, id };
    },
    closeModal: (state, action) => {
      const { modalType } = action.payload;
      state.modals[modalType] = { open: false, id: null };
    },
  },
});

export const { openModal, closeModal } = emailTemplatesControlSlice.actions;
export default emailTemplatesControlSlice.reducer;
